const ADVANTAGES = [
  {
    icon: 'ri-ruler-line',
    title: 'По вашим размерам',
    desc: 'Точный замер на объекте, изготовление перил строго под ваш проём и высоту',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Собственное производство',
    desc: 'Свой цех, контроль на всех этапах — от раскроя металла до финишной сборки',
  },
  {
    icon: 'ri-tools-line',
    title: 'Монтаж под ключ',
    desc: 'Привозим, устанавливаем, закрепляем — вы принимаете готовые перила на объекте',
  },
];

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20modern%20minimalist%20metal%20railing%20on%20a%20staircase%20with%20dark%20charcoal%20frame%20horizontal%20cable%20infill%20warm%20wooden%20steps%20bright%20interior%20natural%20daylight%20from%20large%20window%20contemporary%20home%20design%20clean%20lines%20aesthetic%20architectural%20photography%20realistic%20high%20quality%20wide%20angle%20shot&width=1800&height=1200&seq=railings-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 pt-24 pb-16 md:pt-32 md:pb-24">
        <div className="mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center" style={{ maxWidth: '1400px' }}>
          {/* Left column - text */}
          <div className="text-center lg:text-left animate-fade-in-up">
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4 text-balance">
              Перила, в которых безопасность сочетается с&nbsp;эстетикой
            </h1>
            <p className="text-sm md:text-base text-background-50/80 max-w-lg mx-auto lg:mx-0 mb-3 leading-relaxed">
              Надёжное и красивое ограждение для лестницы, крыльца, балкона или&nbsp;террасы. Точный замер, прочное крепление и&nbsp;дизайн под&nbsp;интерьер или&nbsp;фасад.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-center lg:items-start gap-3 mb-10">
              <a
                href="https://wa.me/79174131562?text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5!%20%D0%A5%D0%BE%D1%87%D1%83%20%D1%80%D0%B0%D1%81%D1%81%D1%87%D0%B8%D1%82%D0%B0%D1%82%D1%8C%20%D1%81%D1%82%D0%BE%D0%B8%D0%BC%D0%BE%D1%81%D1%82%D1%8C%20%D0%BF%D0%B5%D1%80%D0%B8%D0%BB."
                target="_blank"
                rel="noopener noreferrer"
                className="whitespace-nowrap w-full sm:w-auto bg-[#25D366] hover:bg-[#1eb851] text-background-50 font-semibold text-sm px-7 py-3.5 rounded-md transition-all duration-300 hover:scale-[1.03] active:scale-[0.98] cursor-pointer inline-flex items-center justify-center gap-2.5"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-lg"></i>
                </span>
                Рассчитать в WhatsApp
              </a>
              <div className="flex items-center gap-2 flex-wrap justify-center lg:justify-start">
                <a
                  href="https://max.ru/u/f9LHodD0cOICoHyOC2LT2Vx_42oC8Zdm2VV9Uv5O-6mGvkZgeZzUcJQkER0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap bg-accent-600 hover:bg-accent-700 text-background-50 font-medium text-sm px-5 py-3 rounded-md transition-all duration-300 hover:scale-[1.03] active:scale-[0.98] cursor-pointer inline-flex items-center gap-2"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-chat-3-line text-base"></i>
                  </span>
                  Рассчитать в MAX
                </a>
                <a
                  href="https://t.me/share/url?url=&text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5!%20%D0%A5%D0%BE%D1%87%D1%83%20%D1%80%D0%B0%D1%81%D1%81%D1%87%D0%B8%D1%82%D0%B0%D1%82%D1%8C%20%D1%81%D1%82%D0%BE%D0%B8%D0%BC%D0%BE%D1%81%D1%82%D1%8C%20%D0%BF%D0%B5%D1%80%D0%B8%D0%BB."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap bg-[#2AABEE] hover:bg-[#2299d6] text-background-50 font-medium text-sm px-5 py-3 rounded-md transition-all duration-300 hover:scale-[1.03] active:scale-[0.98] cursor-pointer inline-flex items-center gap-2"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-telegram-line text-base"></i>
                  </span>
                  Telegram
                </a>
                <a
                  href="tel:+79174131562"
                  className="whitespace-nowrap border-2 border-background-50/30 hover:border-background-50/60 text-background-50 font-medium text-sm px-5 py-3 rounded-md transition-all duration-300 hover:bg-background-50/10 cursor-pointer inline-flex items-center gap-2"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-fill text-base"></i>
                  </span>
                  Позвонить
                </a>
              </div>
            </div>
          </div>

          {/* Right column - large photo (desktop only) */}
          <div className="hidden lg:block animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
            <div className="relative rounded-lg overflow-hidden border-2 border-background-50/20">
              <div className="w-full h-[420px] xl:h-[500px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Finished%20custom%20metal%20railing%20on%20an%20outdoor%20terrace%20with%20wrought%20iron%20decorative%20balusters%20dark%20charcoal%20color%20warm%20evening%20light%20overlooking%20a%20garden%20private%20house%20modern%20classic%20style%20realistic%20architectural%20photography%20sharp%20detail%20elegant%20design&width=1200&height=900&seq=railings-hero-photo&orientation=portrait"
                  alt="Готовые перила на террасе"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Advantages row */}
        <div className="mx-auto mt-14 md:mt-20" style={{ maxWidth: '1400px' }}>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            {ADVANTAGES.map((item) => (
              <div
                key={item.title}
                className="flex items-start gap-4 bg-background-50/10 backdrop-blur-sm border border-background-50/15 rounded-lg p-4 md:p-5"
              >
                <div className="shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500/20 text-primary-300">
                  <i className={`${item.icon} text-lg md:text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-background-50 mb-1">{item.title}</h3>
                  <p className="text-xs md:text-sm text-background-50/65 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}